import { render, staticRenderFns } from "./ShopNickView.vue?vue&type=template&id=b2bbf67a&scoped=true"
import script from "./ShopNickView.vue?vue&type=script&lang=js"
export * from "./ShopNickView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2bbf67a",
  null
  
)

export default component.exports